module.exports = __webpack_public_path__ + "img/pbt_photo_04.548be5d0.jpg";